export const SET_MENU_LIST = 'set_menu_list';